import { withBusyIndicator } from "@components/busyIndicator/withBusyIndicator";
import SelectionTableViewBase from "@components/smart/selectionTableView/SelectionTableViewBase";

class PickBenefitTableView extends SelectionTableViewBase {
    _keepActiveRowsOnFilterChange = false;

    get secondaryTitle(): string {
        return this.props.storage.t("Benefit:SelectionTableView.Title");
    }

    get selectionConfirmText(): string {
        return this.props.storage.t("Benefit:SelectionTableView.Complete");
    }

    get successMessage(): string {
        return this.props.storage.t("Benefit:SelectionTableView.Success");
    }
}

export default withBusyIndicator({ passBusyIndicator: true })(PickBenefitTableView);
